/**
 * 業務フロー・ステージの図（F2）の oRPC contract。
 *
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business 業務フロー 1 本・ステージの図・案件が変えた業務フローの一覧の読取 procedure の入出力を oRPC contract として定義する。
 * @graph-connects none
 */
import { GetFlowInputSchema, GetFlowOutputSchema, ListPjFlowsInputSchema, ListPjFlowsOutputSchema, } from '../elements/index.js';
import { base } from './common.js';
/**
 * 業務フローの読取 procedure（`specGraph` に載る）。
 * @graph-connects none
 */
export const flowContract = {
    getFlow: base.input(GetFlowInputSchema).output(GetFlowOutputSchema),
    listPjFlows: base.input(ListPjFlowsInputSchema).output(ListPjFlowsOutputSchema),
};
//# sourceMappingURL=flow.js.map